"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
var Check_1 = __importDefault(require("@mui/icons-material/Check"));
var CopyToClipboardButton = function (_a) {
    var text = _a.text, size = _a.size, onClick = _a.onClick;
    var _b = (0, react_1.useState)(false), copied = _b[0], setCopied = _b[1];
    var handleClick = function () {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(function () { setCopied(false); }, 1000);
        if (onClick) {
            onClick();
        }
    };
    return copied
        ? (react_1.default.createElement(material_1.IconButton, { size: size !== null && size !== void 0 ? size : 'medium' },
            react_1.default.createElement(Check_1.default, { fontSize: size !== null && size !== void 0 ? size : 'medium' })))
        : (react_1.default.createElement(material_1.IconButton, { size: size !== null && size !== void 0 ? size : 'medium', onClick: handleClick },
            react_1.default.createElement(ContentCopy_1.default, { fontSize: size !== null && size !== void 0 ? size : 'medium' })));
};
exports.default = CopyToClipboardButton;
